import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useParams } from "react-router-dom";

import CourierProfile from "../components/couriers/CourierProfile";
import CourierDeliveries from "../components/couriers/CourierDeliveries";
import CourierTransactions from "../components/couriers/CourierTransactions";

const Container = styled(Box)({
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
});

const Courier = () => {
    const { firebaseUid } = useParams();
    const [courier, setCourier] = useState(null);

    useEffect(() => {
        const fetchCourier = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/couriers/${firebaseUid}`
                );
                setCourier(res.data.data);
            } catch (error) {
                console.error('Error fetching courier:', error);
                setCourier(null);
            }
        };
        fetchCourier();
    }, [firebaseUid]);

    if (!courier) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Container>
            <Typography variant="h4">Courier Overview</Typography>

            <CourierProfile courier={courier} />
            <CourierDeliveries firebaseUid={firebaseUid} />
            <CourierTransactions transactions={courier.transactions} />
        </Container>
    );
};

export default Courier;
